import { useBoundStore } from '../store'

export const useProfessions = () => 
  useBoundStore((state) => ({
    professionsList: state.professionsList,
    subProfessionLibrary: state.subProfessionLibrary,
    areaOfFocusLibrary: state.areaOfFocusLibrary,
    getProfessions: state.getProfessions,
    areProfessionsLoaded: state.areProfessionsLoaded,
  }))
